import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { deleteVehicle, deleteVehicles } from '../../services/VehiclesService';
import { Vehicle, DeleteVehicleRequest, DeleteVehiclesRequest } from '../../types/Vehicles';

type Result = UseMutationResult<Vehicle, Error, DeleteVehicleRequest>;

function useDeleteVehicle(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(deleteVehicle, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['vehicles'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

type MultiVideoResult = UseMutationResult<Vehicle[], Error, DeleteVehiclesRequest>;

export function useDeleteVehicles(successCb: () => void, failureCb: (error: string) => void): MultiVideoResult {
  const queryClient = useQueryClient();

  return useMutation(deleteVehicles, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['vehicles'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useDeleteVehicle;
